import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'Ssn'
})
export class SsnPipe implements PipeTransform {
    transform(value: string | number | null | undefined): string {
        if (!value) return '';

        const digits = value.toString().replace(/\D/g, '').padStart(15, '0').slice(0, 15);

        const groups = [
            digits.slice(0, 1),  // Sexe
            digits.slice(1, 3),  // Année
            digits.slice(3, 5),  // Mois
            digits.slice(5, 7),  // Département
            digits.slice(7, 10), // Commune
            digits.slice(10, 13),// Ordre
            digits.slice(13, 15) // Clé
        ];

        return groups.filter(g => g).join(' ');
    }
}
